<template>
	<div>
		<app-layout>
			<template v-slot:header>
				<Header :title="$t('route_permissions').toLocaleUpperCase('en-EN')" :isFilter="false">
				</Header>
			</template>
			<template v-slot:header-mobile>
				<HeaderMobile :title="$t('route_permissions').toLocaleUpperCase('en-EN')" :isFilter="false">
				</HeaderMobile>
			</template>
            <b-input
                v-model="datatable.searchText"
                :placeholder="$t('search')"
                class="mb-4"
                @input="filterRows"
            />
			<datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
				:total="datatable.total" :queryParams="datatable.queryParams" v-show="datatable.showTable">
			</datatable>
		</app-layout>
	</div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"

// Components
import Datatable from "@/components/datatable/Datatable";

// Services
import RoutePermissionListServices from "@/services/RoutePermissionListServices";

export default {
	components: {
		AppLayout,
		Header,
		HeaderMobile,
		Datatable,
	},
	metaInfo() {
		return {
			title: this.$t('route_permissions')
		}
	},

	data() {
		return {
			datatable: {
				isLoading: false,
				columns: [
					{
						label: '',
						field: 'buttons',
						html: true,
						sortable: false,
						tdClass: 'p-0 text-center w-40 align-middle',
						buttons: []
					},
					{
						label: this.toUpperCase('id'),
						field: 'id',
						hidden: true,
					},
					{
						label: this.toUpperCase('method'),
						field: 'method',
						hidden: false,
					},
                    {
                        label: this.toUpperCase('permission'),
                        field: 'permission',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('route'),
                        field: 'route',
                        hidden: false,
                    },
				],
				rows: [],
				total: 0,
				filterStatus: true,
				showTable: false,
				queryParams: {
					filter: {},
                    sort: {},
                    limit: -1,
				},
                searchText: '',
                originalRows: [],
            },
            searchableFields: ['method', 'permission', 'route'],
		}
	},
	created() {
        this.getRows()
	},
	methods: {
		filterSet() {
			this.datatable.queryParams.filter = {}
		},
		filterClear() {
			this.filterSet()
			this.getRows();
		},
		filter() {
			this.datatable.queryParams.page = 1;
			this.getRows();
		},
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            return RoutePermissionListServices.getAll()
                .then((response) => {
                    this.datatable.originalRows = response.data.data;
                    this.filterRows();
                    this.datatable.total = response.data.pagination.total;
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        filterRows() {
            const search = this.datatable.searchText?.toLowerCase() || '';

            if (!search) {
                this.datatable.rows = this.datatable.originalRows;
                return;
            }

            this.datatable.rows = this.datatable.originalRows.filter((row) => {
                return this.searchableFields.some(field => {
                    const value = row[field];
                    return value && String(value).toLowerCase().includes(search);
                });
            });
        }
    }
}
</script>

